import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";

let loginid = localStorage.getItem("loginUserID");
let Auth0token = localStorage.getItem("Auth0token");
let UserCompanyId = localStorage.getItem("UserCompanyId");

export async function CheckStorageLimit(FileSize) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
      UserCompanyId +
      "&UserFileSize=" +
      FileSize,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function Checksubaccount() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckSubAccountCount?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function Checkexportdata() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckExportQRCodeDataEnabled?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function CheckQRCodeCategoriesManagementEnabled() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckQRCodeCategoriesManagementEnabled?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function CheckBulkQRcodecount() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckBulkQrCodeCount?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function CheckDynamicPersonalQRcodecount() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckDynamicQRCodeCount?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function CheckStaticPersonalQRcodecount() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckStaticQRCodeCount?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function Checkchatisenabled() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckArticleProductChatEnabled?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function CheckEmailSupportenabled() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckEmailSupportEnabled?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function CheckCheckAPDynamicQrCodeCountenabled() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackageFeature/CheckAPDynamicQrCodeCount?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function UserPackagecancel() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackage/UserPackageCancel?UserCompanyId=" +
      UserCompanyId,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
export async function GetUsrLoginPackageDetail() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl + "UserCompany/GetUserCompanyDetailWithSystemPackageDetail",
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function UserPackageCreate(body) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl + 
    "UserPackage/Create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
    body,
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function CashUserPackageCreate(body) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
     "UserPackage/CreateCashPayment", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
    body,
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function CashUserPendingPackageCreate(body) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(Config.apiUrl + "UserPackage/CreateCustomPackagePaymentCash", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
    body,
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function UserPendingPackageCreate(body) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(Config.apiUrl + "UserPackage/CreateCustomPackagePayment", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
    body,
  })
    .then(handleResponse)
    .catch(handleError);
}
export async function GetAllPackageListWithActivePackage(IsMonthly) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
     "SystemPackage/GetAllPackageListWithActivePackage?IsMonthly="+IsMonthly,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetAllUserWithSystemPackageDetail() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl + "UserCompany/GetAllUserCompanyWithSystemPackageDetail",
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
export async function GetAllUserWithSystemPackageDetailWithSearching(
  UserEmail,
  UserName,
  OS,
  UserPackageID
) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserCompany/GetAllUserCompanyWithSystemPackageDetailNew?Email=" +
      UserEmail +
      "&Name=" +
      UserName +
      "&IsWeb=" +
      OS +
      "&SystemPackageId=" +
      UserPackageID,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetUserWithSystemPackageDetail(userid) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserCompany/GetUserDetailWithAllPackageDetailList?UserID=" +
      userid,

    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetAllSystemPackage() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
     Config.apiUrl +
    "SystemPackage/GetPackageListWithCurrencyList",
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetAllGenericListing(key) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl + "GenericListing/DropdownList?categoryName=" + key,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

// export async function CreateSystempackage(body) {
//   if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
//     Auth0token = await localStorage.getItem("Auth0token");
//   }
//   if (loginid === null || loginid === "" || loginid === undefined) {
//     loginid = await localStorage.getItem("loginUserID");
//   }
//   if (
//     UserCompanyId === null ||
//     UserCompanyId === "" ||
//     UserCompanyId === undefined
//   ) {
//     UserCompanyId = await localStorage.getItem("UserCompanyId");
//   }
//   return fetch(Config.apiUrl + "SystemPackage/Create", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       userCompanyID: loginid,
//       Authorization: "Bearer " + Auth0token,
//     },
//     body,
//   })
//     .then(handleResponse)
//     .catch(handleError);
// }

export async function CreateSystempackage(body) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
    "SystemPackage/CreateNewPackage",
    //"SystemPackage/CreateNewPackage1Days",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body,
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
export async function CreateSystempackage1Dayes(body) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
    "SystemPackage/CreateNewPackage1Days",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body,
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
export async function UpdateSystempackage(body, id) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(Config.apiUrl + "SystemPackage/Update?id=" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
    body,
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function CreateUserCustomPackage(body) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl + 
    "SystemPackage/CreateUserCustomPackageCashNew", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
    body,
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function UserPackagecancelbysupperadmin(userid) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl + "UserPackage/UserPackageCancel?UserCompanyId=" + userid,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function Deleteuserpendingpackagebysupperadmin(
  userPackagePaymentID
) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackagePayment/Delete?userPackagePaymentID=" +
      userPackagePaymentID,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetPreDefinedPackageListByIsWebBySuperadmin(IsWeb , isMonthly) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "SystemPackage/GetYearlyAndMonthlyPackageListWithCurrencyList?IsMonthly=" +
      isMonthly + "&IsWeb="+IsWeb +"&IsCustom="+false,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetFixedCurrencyListSuperadmin() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
     "GenericListing/GetAdminAllCurrencyList",
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetAllCurrencyListSuperadmin() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "GenericListing/GetAllCurrencyDropDownList",
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetPackageDetailWithCurrencyListBySuperadmin(SystemPackageID) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "SystemPackage/GetPackageDetailWithCurrencyList?systemPackageId="+SystemPackageID,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}


export async function IsCheckUserPackageUpgradeOrNot(systemPackageId , userCompanyID , systemPackagePriceID , isstripePay) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl +
      "UserPackage/IsCheckUserPackageUpgradeOrNot?systemPackageId="+systemPackageId+ "&userCompanyID="+userCompanyID +"&systemPackagePriceID="+systemPackagePriceID +"&PaymnetMethoType="+isstripePay,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        // Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getUsrActivePackageDetail() {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(
    Config.apiUrl + "UserPackage/GetActivePackageByUserId?id="+loginid,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getUsrActivePackageDetailByuserid(userid) {
 
  return fetch(
    Config.apiUrl + "UserPackage/GetActivePackageByUserId?id="+ userid,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: userid,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}


export async function GetFullMobileUserDetailByEmailAddress(Email) {
  return fetch(
      Config.apiUrl +
      "UserCompany/GetFullMobileUserDetailByEmailAddress?email=" + Email,
      {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
          },
      }
  )
      .then(handleResponse)
      .catch(handleError);
}


export async function  sendPaymentlink(UserID , PackagePaymentID , PackagePriceID) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  return fetch(
    Config.apiUrl + "SystemPackage/CustomPackagelinksend?UserID="+ UserID + "&PackagePaymentID="+PackagePaymentID +"&PackagePriceID="+ PackagePriceID,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Auth0token,
        userCompanyID: UserID,
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}


// export async function Get() {
//   if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
//     Auth0token = await localStorage.getItem("Auth0token");
//   }
//   if (loginid === null || loginid === "" || loginid === undefined) {
//     loginid = await localStorage.getItem("loginUserID");
//   }
//   if (
//     UserCompanyId === null ||
//     UserCompanyId === "" ||
//     UserCompanyId === undefined
//   ) {
//     UserCompanyId = await localStorage.getItem("UserCompanyId");
//   }
//   return fetch(
//     Config.apiUrl +
//      "GenericListing/GetAdminAllCurrencyList",
//     {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         userCompanyID: loginid,
//         Authorization: "Bearer " + Auth0token,
//       },
//     }
//   )
//     .then(handleResponse)
//     .catch(handleError);
// }
